module.exports = __webpack_public_path__ + "img/skills-lf-ama-3.716f65a3.png";